import { ListResponse } from "@/models/grids/list.response";
import { CreateFeedbackQuestionGroupCommand, EditFeedbackQuestionGroupCommand } from "@/server/app.commands";
import { FeedbackQuestionGroupDto, FeedbackStatsDto } from "@/server/app.dtos";
import { GetFeedbackQuestionGroupDtosQuery, GetSingleFeedbackQuestionGroupDtoQuery } from "@/server/app.queries";
import { AuthenticatedService } from "../abstract/base.service";

export const FeedbackQuestionGroupsEndpoint = `api/feedbackquestiongroups`;

export class FeedbackQuestionGroupsService extends AuthenticatedService {
  GetList(request: GetFeedbackQuestionGroupDtosQuery): Promise<ListResponse<FeedbackQuestionGroupDto>> {
    return this.Get<ListResponse<FeedbackQuestionGroupDto>>(
      `${this.baseUrl}${FeedbackQuestionGroupsEndpoint}?${this.GetQueryStringByObject(request)}`
    );
  }

  GetSingle(request: GetSingleFeedbackQuestionGroupDtoQuery): Promise<FeedbackQuestionGroupDto> {
    return this.Get<FeedbackQuestionGroupDto>(
      `${this.baseUrl}${FeedbackQuestionGroupsEndpoint}/${request.idFeedbackQuestionGroup
      }?${this.GetQueryStringByObject(request)}`
    );
  }

Create(entity: CreateFeedbackQuestionGroupCommand): Promise < number > {
  return this.Post<number>(`${this.baseUrl}${FeedbackQuestionGroupsEndpoint}`, entity);
}

Edit(command: EditFeedbackQuestionGroupCommand): Promise < number > {
  return this.Put<number>(
    `${this.baseUrl}${FeedbackQuestionGroupsEndpoint}/${command.idFeedbackQuestionGroup}`,
    command
  );
}

DeleteById(id: number): Promise < number > {
  return this.Delete(`${this.baseUrl}${FeedbackQuestionGroupsEndpoint}/${id}`);
}
}
